import { render, staticRenderFns } from "./SanctionsBulkUpload.vue?vue&type=template&id=294a5954&scoped=true"
import script from "./SanctionsBulkUpload.vue?vue&type=script&lang=js"
export * from "./SanctionsBulkUpload.vue?vue&type=script&lang=js"
import style0 from "./SanctionsBulkUpload.vue?vue&type=style&index=0&id=294a5954&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294a5954",
  null
  
)

export default component.exports